import './media_boxes.scss';

// import FF_Media_Boxes_v1 from './js/v1';
// import 'src/vendors/isotope/isotope.pkgd.min.js';

// if posts count is greater than 300, use v2
// import FF_Media_Boxes_v2 from './js/v2';
// import './css/v2.scss';

const mb_versions = {
    1: null,
    2: null,
}

document.querySelectorAll('.ff_media_boxes').forEach(container=>{

    const settings = JSON.parse(container.dataset.mb_settings);
    const version = settings.version ?? 1;

    load_mb(version, (MB)=>{
        const mb = new MB(container, settings);
        container.mb = mb;

        const e = new Event('mb_init');
        e.mb = mb;
        document.dispatchEvent(e);
    });

    // container.mb = new FF_Media_Boxes_v1(container, settings);
    // container.mb = new FF_Media_Boxes_v2(container, settings);
})

function load_mb(version, callback){

    if( mb_versions[version] ) {
        callback(mb_versions[version]);
        return;
    }

    if( version === 1 ) {
        import('./js/v1').then(res=>{
            mb_versions[version] = res.default;
            callback(mb_versions[version]);
        });
    }
    else if ( version === 2 ) {
        import('./js/v2').then(res=>{
            mb_versions[version] = res.default;
            callback(mb_versions[version]);
        });
    }
}